<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="name"
          label="Name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <div v-if="debug">
      <code>{{ value }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog";

export default {
  name: "edit-lead-source-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "",
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    editorTitle() {
      return `${this.value && this.value.id ? "Edit" : "Add"} ${
        this.$store.getters.isCPS ? "Operations Team" : "Lead Source"
      } - ${this.name}`;
    },
    isValid() {
      return this.name && this.name !== "";
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.name = newVal.name || "";
      }
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        name: this.name,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/lead-sources/EditLeadSourceDialog.vue